// duongtb fix
var state =
{
    // 'connecting' / disconnected' / 'connected' / 'registered'
    status: 'disconnected',
    //callback scope
    scope: null,
    session: null,
    phoneType: 0,
    auto_answer: 0,
    agentId: "",
    password: "",
    uri: "",
    ws: "",
    isRegistered: false,
    isVoiceActivated: false,
    observers: [],
    subscribe: function (func) {
        this.unsubscribe(func);
        this.observers.push(func);
    },
    unsubscribe: function (func) {
        this.observers = this.observers.filter((observer) => observer !== func);
    },
    sendEvent(data) {
        this.observers.forEach((observer) => observer(data, state.scope));
    }
};

// UA
var ua = null;
var selfView = null;
var remoteView = null;
var iceServers = [
    { urls: ["stun:stun.l.google.com:19302", "stun:global.stun.twilio.com:3478", 'stun:stun.cloudflare.com:3478'] }
    //{ 'urls': ['stun:stun.l.google.com:19302', 'stun:stun1.l.google.com:19302'] }
    // ,{ 'urls': 'turn:example.com', 'username': 'foo', 'credential': ' 1234'}
];
// HTML5 <video> elements in which local and remote video will be shown
// var selfView = document.getElementById('my-video');
// var remoteView = document.getElementById('peer-video');


function sendEvent(data) {
    state.sendEvent(data);
}

function init_ua(agentId, password, uri, ws) {
    if (selfView == null) {
        selfView = document.getElementById('my-video');
        remoteView = document.getElementById('peer-video');
    }
    if (ua) {
        console.log("ua stop");
        ua.stop();
    }
    // cache
    state.agentId = agentId;
    state.password = password;
    state.uri = uri;
    state.ws = ws;
    // end
    var ws2 = null;
    if (uri.indexOf(",") != -1) {
        items = uri.split(",");
        uri = items[0];
        ws = "wss://" + uri;
        ws2 = "wss://" + items[1];
    }
    var socket = new JsSIP.WebSocketInterface(ws);
    var socketList = [];
    socketList.push({ socket: socket, weight: 1 });
    if (ws2 != null) {
        var socketPassive = new JsSIP.WebSocketInterface(ws2);
        socketList.push({ socket: socketPassive, weight: 0 });
    }

    var configuration = {
        sockets: socketList,
        uri: "sip:" + agentId + '@' + uri,
        password: password,
        register_expires: 360,
        trace_sip: true
    };
    console.log("ua " + agentId);
    ua = new JsSIP.UA(configuration);
    // events handler
    ua.on('connecting', function (e) {/* Your code here */
        console.log('ua websocket connecting');
        state.status = 'connecting';
    });
    ua.on('connected', function (e) {/* Your code here */
        console.log('ua websocket connected');
        state.status = 'connected';
    });

    ua.on('disconnected', function (e) { /* Your code here */
        console.log('ua websocket disconnected');
        state.status = 'disconnected';
    });

    ua.on('registered', function (e) { /* Your code here */
        console.log('ua registered');
        state.status = 'registered';
        state.isRegistered = true;
        sendEvent('registered');
    });

    ua.on('unregistered', function (e) { /* Your code here */
        console.log('ua unregistered');
        if (ua.isConnected()) {
            state.status = 'unregistered';
        }
        else {
            state.status = 'disconnected';
        }
        state.isRegistered = false;
        sendEvent('unregistered');
    });

    ua.on('registrationFailed', function (e) { /* Your code here */
        console.log('ua registrationFailed ' + e.cause);
        if (ua.isConnected()) {
            state.status = 'unregistered';
        }
        else {
            state.status = 'disconnected';
        }
        state.isRegistered = false;
        sendEvent('registrationFailed');

    });

    //https://jssip.net/documentation/3.10.x/api/session/
    //https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/icecandidate_event

    ua.on('newRTCSession', function (e) {/* Your code here */
        console.log('ua newRTCSession');
        sendEvent('newRTCSession');
        var session = state.session = e.session;

        session.on('progress', function (e) {
            console.log('ua progress 1XX SIP response');
            var remote_identity = session.remote_identity;
            if (remote_identity) {
                var uri = remote_identity.uri;
                if (uri) {
                    var user = uri.user
                    console.log(user);
                }
            }
        });
        session.on('accepted', function (e) {
            console.log('ua has answered 2XX SIP response');
            state.session = session;
            var peerconnection = session.connection;
            // var localStream = peerconnection.getLocalStreams()[0]; 
            // if (selfView) {
            //     selfView.srcObject = localStream;
            // }
            // var remoteStream = peerconnection.getRemoteStreams()[0];
            // if (remoteView) {
            //     remoteView.srcObject = remoteStream;
            // }
            var receivers = peerconnection.getReceivers();
            var remoteReceiver = receivers[0];
            var newStream = new MediaStream([remoteReceiver.track]);
            remoteView.srcObject = newStream;
            sendEvent('accepted');
        });
        session.on('failed', function (e) {
            destroyCall();
            console.log('ua failed ' + e.cause);
            if ("Canceled" != e.cause) {
                sendEvent('failed');
                sendEvent({error:'Lỗi kết nối tới web phone ' + e.cause});
            }
        });
        session.on('ended', function (e) {
            destroyCall();
            console.log('ua ended ' + e.cause);
            sendEvent('ended');
        });

        // other events for debugging

        // session.on('icecandidate', function (e) {
        //     console.log('ua icecandidate ' + JSON.stringify(e));
        // });
        // session.on('sdp', function (e) {
        //     console.log('ua sdp ' + JSON.stringify(e));
        // });
        // session.on('confirmed', function (e) {
        //     console.log('ua confirmed SIP ACK');
        // });
        // session.on('connecting', function (e) {
        //     console.log('ua connecting SIP INVITE');
        // });

        // session.on('newInfo', function (e) {
        //     console.log('ua newInfo SIP INFO');
        // });
        // session.on('newDTMF', function (e) {
        //     console.log('ua newDTMF');
        // });
        // session.on('peerconnection', function (e) {
        //     console.log('ua peerconnection is created');
        // });
        session.on('getusermediafailed', function (e) {
            console.log('ua getUserMedia() fails', e);
        });
        // session.on('reinvite', function (e) {
        //     console.log('ua reinvite');
        // });
        // session.on('refer', function (e) {
        //     console.log('ua refer');
        // });
    });
    // reset call
    this.terminate_call();
    destroyCall();
    ua.start();
}

function register() {
    if (!state.isVoiceActivated) {
        if (state.isRegistered) {
            unregister();
        }
        showError("Voice tab is not activated!");
        return;
    } else if (!state.phoneType == 0) {
        if (state.isRegistered) {
            unregister();
        }
        showError("Agent does not configure to use webrtc phone!");
        return;
    }
    checkBrowser();
    if (!ua || !ua.isRegistered()) {
        init_ua(state.agentId, state.password, state.uri, state.ws);
    }
}

function unregister() {
    if (ua && ua.isRegistered()) {
        ua.unregister();
    }
}

function dial_call(uri) {

    if (!ua || !ua.isRegistered()) {
        console.log("ua is not registered, register now");
        init_ua();
    }
    // Register callbacks to desired call events
    var eventHandlers = {
        'progress': function (e) {
            console.log('call is in progress');
        },
        'failed': function (e) {
            console.log('call failed with cause:');
            destroyCall();
        },
        'ended': function (e) {
            console.log('call ended with cause:');
            destroyCall();
        },
        'confirmed': function (e) {
            console.log('call confirmed');
        }
    };
    var options = {
        'eventHandlers': eventHandlers,
        // 'extraHeaders': [ 'X-Foo: foo', 'X-Bar: bar' ],
        'mediaConstraints': { 'audio': true, 'video': false },
        'sessionTimersExpires': 18000,
        'pcConfig': {
            rtcpMuxPolicy: "require",
            'iceServers': iceServers
        },
        rtcOfferConstraints: {
            offerToReceiveAudio: 1,
            offerToReceiveVideo: 0
        }
    };

    ua.call(uri, options);
}

function answer_call() {
    console.log('ua answer_call');
    var session = state.session;
    console.log('ua session ', session);
    try {
        if (session) {
            session.answer({
                // pcConfig: peerconnection_config,
                // TMP:
                sessionTimersExpires: 18000,
                mediaConstraints: { audio: true, video: false },
                // extraHeaders: [
                //   'X-Can-Renegotiate: ' + String(localCanRenegotiateRTC())
                // ],
                pcConfig: {
                    rtcpMuxPolicy: "require", //require   -  negotiate
                    'iceServers': iceServers
                },
                rtcOfferConstraints: {
                    offerToReceiveAudio: 1,
                    offerToReceiveVideo: 0
                }
            });
        }
    } catch (e) {
        console.log('ua answer_call error ', e);
        sendEvent({error:'Lỗi kết nối tới web phone ' + e.message});
    }
}

function terminate_call() {
    var session = state.session;
    if (session) {
        try {
            session.terminate();
        } catch (e) {
            console.log("terminate error", e);
        }
    }
    this.destroyCall();
}

function sendDTMF(digit) {
    var session = state.session;
    if (session) {
        session.sendDTMF(digit);
    }
}
function destroyCall() {
    state.session = null;
    if (selfView) {
        selfView.srcObject = null;
    }
    if (remoteView) {
        remoteView.srcObject = null;
    }
}

function hasWebRTC() {
    if (navigator.webkitGetUserMedia) {
        return true;
    } else if (navigator.mozGetUserMedia) {
        return true;
    } else if (navigator.getUserMedia) {
        return true;
    } else {
        sendEvent('Unsupported Browser. Your browser does not support the features required for this phone.');
        console.log("WebRTC support not found");
        return false;
    }
}

function checkBrowser() {
    if (!hasWebRTC()) {
        sendEvent('Unsupported Browser. Your browser does not support the features required for this phone.');
        return;
    }
    var constraints = { audio: true };
    navigator.mediaDevices.getUserMedia(constraints)
        .then(stream => {
            sendEvent('Kết nối tới thiết bị nghe gọi của bạn thành công');
        })
        .catch(e => {
            if (DetectRTC.isWebRTCSupported === false) {
                sendEvent('Trình duyệt của bạn không hỗ trợ thiết bị nghe gọi, xin vui lòng thử trình duyệt khác');
            }
            if (DetectRTC.hasMicrophone === false) {
                sendEvent('Không thể kết nối tới thiết bị nghe gọi của bạn. Hãy kiểm tra lại tai nghe và micro của bạn');
            }

            if (DetectRTC.hasSpeakers === false && (DetectRTC.browser.name === 'Chrome' || DetectRTC.browser.name === 'Edge')) {
                sendEvent('Micro của bạn gặp vấn đề. Xin vui lòng kiểm tra lại micro của bạn');
            }
        });
}
function showError(message) {
    console.log(message);
}
function showInfo(message) {
    console.log(message);
}
function showSuccess(message) {
    console.log(message);
}


// WEBPACK FOOTER //
// src/assets/evs/js/phonesdk.js